import React from "react";
import { TrendingUp, BarChart3, CheckCircle2 } from "lucide-react";
import { LIVE_TRADES, MONTHLY_RETURNS } from "../mock";

export default function LiveResults() {
  const max = Math.max(...MONTHLY_RETURNS.map((r) => r.v));
  return (
    <section id="results" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center reveal">
          <span className="text-[12px] tracking-[0.25em] text-[#2e9bff] font-semibold">MT5 RESULTS</span>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-white mt-4">
            Live MT5 Result — <span className="text-blue-grad">Up 10% to 50%</span><br className="hidden lg:block" /> Monthly Profit
          </h2>
          <p className="text-slate-400 mt-4 max-w-2xl mx-auto">All trades verified on MetaTrader 5. Real accounts, real profits. No simulations.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-6 mt-14">
          <div className="glass-card rounded-2xl p-6 reveal">
            <div className="flex items-center justify-between mb-5">
              <h3 className="flex items-center gap-2 font-semibold text-white"><TrendingUp className="w-5 h-5 text-[#2e9bff]" /> Live Trade History</h3>
              <span className="flex items-center gap-2 text-[12px] text-[#22e39a] font-semibold"><span className="w-2 h-2 rounded-full bg-[#22e39a] live-dot" /> LIVE</span>
            </div>
            <div className="space-y-1">
              {LIVE_TRADES.map((t, i) => (
                <div key={i} className="flex items-center justify-between py-3 px-3 rounded-lg hover:bg-[rgba(46,155,255,0.06)] transition-colors border-b border-white/5 last:border-0">
                  <div className="flex items-center gap-3">
                    <span className={`text-[11px] font-bold px-2 py-0.5 rounded ${t.side === "BUY" ? "bg-[#22e39a]/15 text-[#22e39a]" : "bg-red-500/15 text-red-400"}`}>{t.side}</span>
                    <span className="text-slate-200 text-sm font-medium">{t.pair}</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="text-[#22e39a] font-bold text-sm">{t.pnl}</span>
                    <span className="text-slate-500 text-xs w-14 text-right">{t.time}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="glass-card rounded-2xl p-6 reveal">
            <div className="flex items-center justify-between mb-5">
              <h3 className="flex items-center gap-2 font-semibold text-white"><BarChart3 className="w-5 h-5 text-[#2e9bff]" /> Monthly Returns</h3>
              <span className="text-[12px] text-slate-400 px-3 py-1 rounded-full bg-[#0f1b30] border border-white/5">2024–2025</span>
            </div>
            <div className="space-y-4">
              {MONTHLY_RETURNS.map((r) => (
                <div key={r.m} className="flex items-center gap-3">
                  <span className="text-slate-400 text-sm w-9">{r.m}</span>
                  <div className="flex-1 h-3.5 rounded-full bg-[#0f1b30] overflow-hidden">
                    <div className="h-full rounded-full" style={{ width: `${(r.v / max) * 100}%`, background: "linear-gradient(90deg,#2e9bff,#6fc3ff)" }} />
                  </div>
                  <span className="text-[#22e39a] font-bold text-sm w-12 text-right">+{r.v}%</span>
                </div>
              ))}
            </div>
            <div className="mt-6 flex items-start gap-3 p-4 rounded-xl bg-[rgba(34,227,154,0.06)] border border-[rgba(34,227,154,0.2)]">
              <CheckCircle2 className="w-5 h-5 text-[#22e39a] mt-0.5 shrink-0" />
              <div>
                <p className="text-white font-semibold text-sm">MT5 Verified Account</p>
                <p className="text-slate-400 text-xs mt-0.5">Real money, real trades. All results independently verified.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
